import { RadioOption } from './RadioGroupField'

export function recordToSortedRadioOptions<E extends string | number>(record: Record<E, string>): RadioOption<E>[] {
  return Object.keys(record).map((key) => ({
    value: key as E,
    label: record[key as E],
  }))
}
